module.exports = __webpack_public_path__ + "static/tactics_collection_fotbal-adadb6e2e9276f856d4dad6a1e383756.mp4";